export const updateFavicon = (favicon: string) => {
  const linkElement = document.head.querySelector("link[rel*='icon']") as HTMLLinkElement;
  const currentFavicon = linkElement.href.substring(linkElement.href.lastIndexOf('/') + 1);
  const modifiedUrl = linkElement.href.replace(currentFavicon, favicon);
  linkElement.href = modifiedUrl;
};
